import axios from "axios";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Users2 } from "lucide-react";
import { DEFAULT_AVATAR } from "../../../../../utils/fallbackImages";

export default function MembersLayerData() {
  const session_id = Cookies.get("jwt");
  const [dataDetailLayer, setDataDetailLayer] = useState([]);
  const [dataDetailPage, setDataDetailPage] = useState(null);

  useEffect(() => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const dataValue = url.searchParams.get("data");
    setDataDetailPage(dataValue ? parseInt(dataValue) : 1);
  }, []);

  useEffect(() => {
    if (dataDetailPage !== null) {
      axios
        .get(
          `${process.env.REACT_APP_API}/mlm/invited-detail?layer=${dataDetailPage}`,
          {
            headers: {
              Authorization: `Bearer ${session_id}`,
            },
          }
        )
        .then((res) => {
          setDataDetailLayer(res.data.invitees || []);
        })
        .catch((error) => {
          console.error(error);
          setDataDetailLayer([]);
        });
    }
  }, [dataDetailPage, session_id]);

  return (
    <div className="min-h-screen bg-gray-50 lg:pt-20">
      <div className="max-w-2xl mx-auto px-4 py-8 space-y-4">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center justify-between"
        >
          <Link
            to={dataDetailPage === 1 ? "/members/layer" : `/members/layer/desc?data=${dataDetailPage - 1}`}
            onClick={() => setDataDetailPage((prev) => Math.max(prev - 1, 1))}
            className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0"
          >
            <ChevronLeft className="w-4 h-4 text-gray-500" />
          </Link>

          <div className="text-center">
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">สมาชิก</p>
            <h1 className="text-lg font-bold text-gray-900">ชั้นที่ {dataDetailPage}</h1>
          </div>

          {dataDetailPage !== 10 ? (
            <Link
              to={`/members/layer/desc?data=${dataDetailPage + 1}`}
              onClick={() => setDataDetailPage((prev) => Math.min(prev + 1, 10))}
              className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0"
            >
              <ChevronRight className="w-4 h-4 text-gray-500" />
            </Link>
          ) : (
            <div className="w-9" />
          )}
        </motion.div>

        {/* Count pill */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.04 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-6 py-5"
        >
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">สมาชิกในชั้นนี้</p>
          <div className="flex items-baseline gap-1.5">
            <span className="text-4xl font-bold text-blue-600">{dataDetailLayer.length}</span>
            <span className="text-base text-gray-400 font-medium">คน</span>
          </div>
        </motion.div>

        {/* Member list */}
        {dataDetailLayer.length > 0 ? (
          <div className="space-y-2">
            {dataDetailLayer.map((data, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.35, delay: index * 0.04 }}
                className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-4"
              >
                <div className="relative flex-shrink-0">
                  <img
                    src={data.profile_image}
                    className="w-12 h-12 rounded-full object-cover ring-2 ring-white shadow-sm"
                    alt={`${data.uname}'s profile`}
                    onError={(e) => { e.target.src = DEFAULT_AVATAR; }}
                  />
                  <div className="absolute -top-1 -right-1 w-5 h-5 bg-blue-600 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                    {index + 1}
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-800 truncate">{data.uname}</p>
                  <p className="text-xs text-gray-400 mt-0.5">สมาชิก</p>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.06 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center py-16 gap-3 text-gray-400"
          >
            <div className="w-14 h-14 bg-gray-100 rounded-2xl flex items-center justify-center">
              <Users2 className="w-7 h-7 opacity-30" />
            </div>
            <p className="text-sm">ไม่มีข้อมูลสมาชิกในระดับนี้</p>
          </motion.div>
        )}

        <div className="h-8" />
      </div>
    </div>
  );
}
